<div class="view-component">
    <div class="view-component-title">
        <span class="title">Fluxo de Status</span>
    </div>

    <div class="maindiv-notab">
        <simple-datagrid entityName='Mktpstatus' parentRow=""  [condition]="codition" [nodata]="nodata" ></simple-datagrid>
        
    </div>
    
</div>